import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Move {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  service: "move" | "pack_and_move" | "labor";
  date: string;
  // Add other move properties as needed
}

interface MovesState {
  moves: Move[];
  selectedMove: Move | null;
}

const initialState: MovesState = {
  moves: [],
  selectedMove: null,
};

const movesSlice = createSlice({
  name: "moves",
  initialState,
  reducers: {
    setMoves: (state, action: PayloadAction<Move[]>) => {
      state.moves = action.payload;
    },
    addMove: (state, action: PayloadAction<Move>) => {
      state.moves.push(action.payload);
    },
    updateMove: (state, action: PayloadAction<Move>) => {
      const index = state.moves.findIndex(
        (move) => move.id === action.payload.id
      );
      if (index !== -1) {
        state.moves[index] = action.payload;
      }
    },
    deleteMove: (state, action: PayloadAction<string>) => {
      state.moves = state.moves.filter((move) => move.id !== action.payload);
    },
    setSelectedMove: (state, action: PayloadAction<Move | null>) => {
      state.selectedMove = action.payload;
    },
  },
});

export const { setMoves, addMove, updateMove, deleteMove, setSelectedMove } =
  movesSlice.actions;

export default movesSlice.reducer;
